const registry = new Map();
export function registerArtifactPlugin(plugin) {
  if (registry.has(plugin.artifactType)) {
    // eslint-disable-next-line no-console
    console.warn(`[breeze-artifacts-sdk] Overwriting existing plugin for artifactType "${plugin.artifactType}". ` + 'This usually means two modules registered the same type.');
  }
  registry.set(plugin.artifactType, plugin);
}
export function getPluginRegistry() {
  return registry;
}
export function getContributionsForSurface(artifactType, surface) {
  const plugin = registry.get(artifactType);
  if (!plugin) return undefined;
  return plugin.contributions.find(c => c.surface === surface);
}